<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
export default {
  name: 'App',
  created() {  
    var loading = document.getElementById('loading');
    if(loading !=null) {
      document.body.removeChild(loading);
    }  
  }
}
</script>
<style>
html {
  width: 100%;
  height: 100%;
}
html body {
  width: 100%;
  height: 100%;
  font-size: 0;
  background-color: #fff;
}
#app {
  /*font-family: -apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,PingFang SC,Noto Sans,Noto Sans CJK SC,Microsoft YaHei !important;*/
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /*margin-top: 30px;*/
}
h1,h2,h3,h4 {
  font-weight: 400;
}

h1 {
  font-size: 2rem;
  line-height: 3rem;
  letter-spacing: 12px;
  text-transform: uppercase;
  padding-bottom: 8px;
  font-weight: 300;
}

h2 {
 /* color: #e44c65;*/
  font-size: 1.2rem;
  font-weight: bold;
  letter-spacing: 4px;
  text-transform: uppercase;
}

h3 {
  font-size: 14px;
/*  text-transform: uppercase;*/
  letter-spacing: 2px;
  line-height: 1.5;

}

p {
 /* color: #888;*/
  font-size: 20px;
  letter-spacing: 1px;
  line-height: 34px;
}

body, h1, h2, h3, h4, h5, p, div, ul, li, a, span {
  font-family: "-apple-system","BlinkMacSystemFont","Segoe UI","Roboto","Segoe UI","Helvetica Neue","PingFang SC","Noto Sans","Noto Sans CJK SC","Microsoft YaHei","微软雅黑","sans-serif";
}
</style>



// WEBPACK FOOTER //
// src/App.vue